import { PlayerClassType } from "../../enum/PlayerClassType";
import { MetersToUnits, toPixels } from "../../util";
import Player from "../Player";
import PlayerClass from "../PlayerClass";
import Gun from "../Gun";
import Ability from "../Ability";
import { KeyCode } from "../../lib/Input";
import AfterBurnerDash from "../abilities/fighter/AfterburnerDash";
import EMP from "../abilities/fighter/EMP";
import ShieldOvercharge from "../abilities/fighter/ShieldOvercharge";
import TwinMachineGun from "../guns/fighter/TwinMachineGun";
import HomingRockets from "../guns/fighter/HomingRockets";

export default class Fighter extends PlayerClass {

    

    constructor(player: Player) {
        super(PlayerClassType.Fighter, player, new TwinMachineGun(player), new HomingRockets(player));

        this.player.hp = this.player.maxHp = 800;
        this.player.energy = this.player.maxEnergy = 100;
        this.player.accelerationForce = toPixels(MetersToUnits(100));
        this.player.size = 8;

        this.abilities = [
            new AfterBurnerDash(this.player),
            new EMP(this.player),
            new ShieldOvercharge(this.player)
        ];
    }

    Draw(color: string): void {
        this.ctx.strokeStyle = color;
        this.ctx.fillStyle = color + "55";
        this.ctx.lineWidth = this.player.damageReductionModifier > 0 ? 2 : 1;

        //draw player
        const p1 = this.player.transform.position.add(this.player.transform.forward.scale(this.player.size));
        const p2 = this.player.transform.position.add(this.player.transform.right.rotate(Math.PI/5).scale(this.player.size));
        const p3 = this.player.transform.position.add(this.player.transform.back.scale(this.player.size/2));
        const p4 = this.player.transform.position.add(this.player.transform.left.rotate(-Math.PI/5).scale(this.player.size));

        this.player.engine.fillShape(p1, p2, p3, p4);
        this.player.engine.strokeShape(p1, p2, p3, p4);
        //

        super.Draw(color);
    }

}